import { useEffect } from 'react';
import { markTrustOfferEligible } from '../utils/trustedComputer';

/**
 * v3.91.0 — "Don't ask for a code on this computer" is offered only in a
 * browser where the global administrator has been signed in (the code screen
 * cannot know who is signing in). Marks this browser once the signed-in user
 * is the global administrator in their own session — never while an
 * administrator is viewing as someone else.
 */
export default function useTrustOfferFlag(user, isImpersonating) {
  useEffect(() => {
    let viewingAs = false;
    try { viewingAs = window.sessionStorage.getItem('isImpersonating') === 'true'; } catch (err) { viewingAs = false; }
    if (user?.role?.admin === true && !isImpersonating && !viewingAs) markTrustOfferEligible();
  }, [user, isImpersonating]);
}
